export default "__VITE_ASSET__CWy1gkWd__"